import { useEffect, useState } from "react";
import { getCurrentCacheAction } from "../apis/cache.api";
const DELIMITER = ":";
const useCurrentActionCache = () => {
  const [currentActionCache, setCurrentActionCache] = useState("");

  useEffect(() => {
    // call api get current cache from server
    getCurrentCacheAction((result) => {
      if (result) {
        const [, modelCache] = result.split(DELIMITER);
        if (currentActionCache !== modelCache) {
          setCurrentActionCache(modelCache);
        }
      } else {
        setCurrentActionCache("");
      }
    });
  }, [currentActionCache]);

  return { currentActionCache, setCurrentActionCache };
};

export default useCurrentActionCache;
